import { ModeUI } from '@/constants/enum';
import useColorMode from '@/hook/useColorMode';
import ReactECharts, { EChartsInstance } from 'echarts-for-react';
import _ from 'lodash';
import 'echarts/theme/dark';
import { useEffect, useState } from 'react';

interface ECharts {
    title?: string
    height?: number
    isLoading?: boolean
    color?: string[]
    legend?: object
    toolbox?: object
    tooltip?: object
    grid?: object
    series: any
    xAxis: object
    yAxis?: object
    onClick?: () => void
    dataZoom: object[]
}

export default function ECharts(props: ECharts) {
    const {title, xAxis, yAxis, series, height, tooltip, color = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'], toolbox, onClick, legend, isLoading, grid, dataZoom = []} = props
    const [mode, setMode] = useState<ModeUI>(useColorMode().mode)
    
    useEffect(() => {
        const handler = () => {
            let updated = localStorage.getItem('color-theme');
            if(updated) {
            updated = JSON.parse(updated)
            if(updated === ModeUI.AUTO) {
                updated = window.matchMedia && window.matchMedia("(prefers-color-scheme:dark)").matches ? ModeUI.DARK : ModeUI.LIGHT
            }
            setMode(updated as ModeUI)
            }
        }

        window.addEventListener('local-storage-updated', handler);
        return () => window.removeEventListener('local-storage-updated', handler);
    }, []);

    const option = {
        title: {
            text: title,
            show: !_.isEmpty(title)
        },
        tooltip: {
            ...tooltip
        },
        color: color,
        toolbox:  {
            feature: {
                saveAsImage: {},
                dataZoom: {},
                restore : {},
            },
            ...toolbox
        },
        grid: {
          left: 50,
          top: 40,
          right: 30,
          bottom: 60,
          ...grid
        },
        legend: {
            ...legend
        },
        xAxis: {
            boundaryGap: false,
            scale: true,
            ...xAxis
        },
        yAxis: {
            type: 'value',
            // min: 0,
            ...yAxis
        },
        dataZoom: dataZoom,
        series: series
    };

    const onEvents = {
        click: onClick,
    } as Record<string, Function>

    const onChartReadyCallback = (data: EChartsInstance) => {}

    return <ReactECharts
        key={mode === ModeUI.DARK ? "dark" : "light"}
        option={option}
        style={{ height, width: '100%' }}
        onEvents={onEvents}
        // theme={mode === ModeUI.DARK ? "dark" : "white"}
        notMerge={true}
        lazyUpdate={true}
        onChartReady={onChartReadyCallback}
        showLoading={isLoading}
        // opts={{renderer: 'svg'}}
    />;
}